<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative mb-20 md:mb-0 pb-20">
    <Pagesubtitle subTitle="Add your own polls or open questions for positive customers."/>
    <vx-card title="1. Choose a question" class="mb-5 pb-0 addq">
      <p class="mb-3">What do you want to know?</p>
      <vs-input
      v-validate="'required|min:3|max:100'"
      data-vv-validate-on="blur"
      data-vv-as="question text"
      name="questionText"
      v-model.trim="currentQuestionText"
      placeholder="Type your question here..."
      size="large"
      class="w-full"></vs-input>

      <vs-alert v-if="!showQuestionTips" class="mt-2">
        <div class="my-2 flex items-center">
          <feather-icon icon="InfoIcon" svgClasses="stroke-current text-light w-6 h-6" class="mx-2" />
          <span class="inline-block max-w-lg text-dark font-normal">If needed, change the question to suit your business better.</span>
        </div>
      </vs-alert>

      <div class="my-2 p-4" style="background: #FAFAFA">
        <p class="mb-3">Which customers should see this question?</p>
        <vs-slider class="w-full" :color="getSliderColor(ratingScale[0])" :min="0" :max="10" v-model="ratingScale" />
        <p class="my-1 text-sm">Only customers who give a rating of <span class="font-medium">{{ getRatingString(ratingScale[0],ratingScale[1]) }}</span> will see this.</p>
      </div>
      <span class="text-danger text-sm my-2">{{ errors.first('questionText') }}</span>
          <div class="vx-row px-4 pt-4" v-if="showQuestionTips">
            <div class="w-full md:w-1/2 lg:w-1/4 md:pr-6" v-for="(group, i) in $store.state.dash.questionTemplates.allBusinesess" v-if="i < 4">
              <h6 class="my-2 uppercase">{{ group.groupName }}</h6>
              <a href="" class="block mb-4 text-light underline" v-for="(question,j) in group.questions" @click.prevent="populateQuestion('allBusinesess',i,j)" v-if="j < 4">{{ question.questionText.replace(/_businessname_/g, $store.state.dash.viewData.business.businessInfo.businessName) }}</a>
            </div>
          </div>
          <vs-button @click="showAllQuestions = true" type="flat" class="block w-64 mx-auto mt-2">{{ showQuestionTips ? 'All':'View' }} Templates ></vs-button>
          <vs-popup class="holamundo" :fullscreen="true"  :title="typeof $route.query['showtemplates'] !== 'undefined' ? 'Select question template':'Question Templates'" :active.sync="showAllQuestions">
            <div class="vx-row lg:px-6 md:py-4">
              <div class="vx-col w-full sm:w-1/2 lg:w-1/3 px-6 lg:px-16 mb-base lg:mb-16 flex mb-10" v-for="(group, i) in $store.state.dash.questionTemplates.allBusinesess">
              <div>
                <h4 class="mb-4 uppercase text-dark">{{ group.groupName }}</h4>
                <div v-for="(question,j) in group.questions" class="mb-10">
                  <a href="" class="block font-medium"  @click.prevent="populateQuestion('allBusinesess',i,j)">{{ question.questionText.replace(/_businessname_/g, $store.state.dash.viewData.business.businessInfo.businessName) }}</a>
                  <p class="my-1 text-sm text-light">{{ question.questionType !== 'singleq' ? (question.questionType === 'openq' ? 'Open answer' : 'Choose multiple:') : 'Choose one:' }} {{ question.answerOptions.map(q => q.text).join("; ") }}</p>
                  <p class="m-0 text-dark">{{question.description}}</p>
                  <vs-button type="line" href="" class="text-dark text-sm" @click.prevent="populateQuestion('allBusinesess',i,j)">Use ></vs-button>
                </div>
              </div>
              </div>
            </div>
          </vs-popup>
    </vx-card>
    <vx-card title="2. Choose question type" class="mb-5 pb-4 addq">
      <p class="mb-3">What kind of question would you like to ask?</p>
      <div class="vx-row lg:w-3/4">
        <div class="vx-col w-full md:w-1/3 my-6 md:my-0 md:px-2">
          <vs-radio v-model="questionType" vs-value="openq" class="text-dark font-medium">
          <img src="@/assets/images/misc/opentextanswer.png" class="w-64"/>
          <p class="text-center">Free-form text answer</p>
          </vs-radio>
        </div>
        <div class="vx-col w-full md:w-1/3 my-6 md:my-0 md:px-2">
          <vs-radio v-model="questionType" vs-value="singleq" class="text-dark font-medium">
          <img src="@/assets/images/misc/singlechoiceanswer.png" class="w-full max-w-xs"/>
          <p class="text-center">Single choice</p>
          </vs-radio>
        </div>
        <div class="vx-col w-full md:w-1/3 my-6 md:my-0 md:px-2">
          <vs-radio v-model="questionType" vs-value="multiq" class="text-dark font-medium">
          <img src="@/assets/images/misc/multiplechoiceanswer.png" class="w-full max-w-xs"/>
          <p class="text-center">Multiple choice</p>
          </vs-radio>
        </div>
      </div>
    </vx-card>
    <vx-card title="3. Choose possible answers" class="mb-5 pb-4 addq" v-if="questionType !== 'openq'">
      <p class="mb-3">What options do you want as answers?</p>
      <div class="w-20">
        <div v-for="(option, i) in questionOptions">
          <vs-input
          v-validate="'min:1|max:20'"
          data-vv-validate-on="blur"
          data-vv-as="'option'"
          :name="'Option' + i"
          class="w-full sm:w-auto my-2 inline-block"
          v-model.trim="option.text"
          :placeholder="'Option ' + (i + 1)" />
          <vs-button type="flat" class="my-2 inline-block" v-if="i > 1" @click="removeQuestionOption(i)">x Remove</vs-button>
          <span class="block text-danger text-sm my-2">{{ errors.first('Option' + i) }}</span>
          <vs-divider class="sm:hidden"/>
        </div>
        <vs-button type="border" class="my-2" v-if="questionOptions.length < 5" @click="() => { questionOptions.push({text: ''}) }">+ Add option</vs-button>
      </div>
    </vx-card>
    <savebutton submitText="Save Question" :accept="addQuestion" :goodToGo="formReady" :cancel="cancel" />
  </div>
</template>


<script>

import Savebutton from './components/ptcomponents/Savebutton.vue'
import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'

function initialState (){
  return {
    showAllQuestions: false,
    showQuestionTips: true,
    currentQuestionText: '',
    questionType: 'openq',
    ratingScale: [7,10],
    questionOptions: [{
      text: ''
    }, {
      text: ''
    }]
  }
}


export default {
  data () {
    return initialState()
  },
  components: {
    Savebutton,
    Pagesubtitle
  },
  computed: {
    formReady() {
      if (this.currentQuestionText.length > 0) {
        if (this.questionType !== 'openq') {
          let optionsGood = true
          this.questionOptions.forEach((o,i) => {
            if (i < 2) {
              if (o.text.length === 0) {
                  optionsGood = false
              }
            }
          })
          if (!optionsGood) {
            return false
          }
        }
        return true
      }
      return false
    }
  },
  created () {
    Object.assign(this.$data, initialState());
    if (typeof this.$route.query['showtemplates'] !== "undefined") {
      setTimeout(() => {
        this.showAllQuestions = true
      }, 200)
    }
  },
  methods: {
    getRatingString(min, max) {
      //if (min === 0 && max === 10) return ''
      return min === max ? min : min + ' - ' + max
    },
    getSliderColor(minRating) {
      return minRating <= 5 ? 'danger' : minRating <= 7 ? 'warning' : 'success'
    },
    populateQuestion(collection, i, j) {

      this.showQuestionTips = false
      this.showAllQuestions = false

      let question = this.$store.state.dash.questionTemplates[collection][i].questions[j]

      this.currentQuestionText = question.questionText.replace(/_businessname_/g, this.$store.state.dash.viewData.business.businessInfo.businessName)
      this.questionType = question.questionType
      this.questionOptions = question.answerOptions.length === 0 ? [{
        text: ''
      }, {
        text: ''
      }] : question.answerOptions

      //noconsoleconsole.log()

    },
    cancel() {
      this.$router.push('/dash/surveyflow')
    },
    addQuestion() {
      let payload

      let answerSetup = []

      this.questionOptions.forEach((o,i) => {
        if (o.text.trim() !== '') {
          answerSetup.push(o.text)
        }
      })

      let qDetail = {
        questionText: this.currentQuestionText,
        questionType: this.questionType,
        answerOptions: answerSetup,
        ratingScale: this.ratingScale
      }

      this.$store.dispatch('dash/ADD_NEW_QUESTION', qDetail).then(() => {
        this.$vs.notify({
          title:'Add new question',
          text:'Question added successfully',
          color:'success',
          time: 4000,
          iconPack: 'feather',
          icon:'icon-check'})          
      }).catch(() => {
        this.$vs.notify({
          title:'Add new question',
          time: 10000,
          text:'Oops! Something went wrong, and we couldn\'t add your question. Please try again, or reach out for support if it happens again.',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-alert-circle'})
      })

      this.$router.push('/dash/surveyflow')

    },
    removeQuestionOption(i) {
      this.questionOptions.splice(i,1)
    }
  }
}
</script>

<style lang="scss" >

.addq .vx-card__title {
    font-size: 110% !important;
    h4 {
      font-weight: 500 !important;
    }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>
